import type {
  ProductFamilyDetail,
  ProductFamilyPagedResult,
  QueryParams,
} from '~/types/api'

export function createProductFamiliesRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'product-families'

  async function getAll(params?: QueryParams) {
    return get<ProductFamilyPagedResult>([DOMAIN], { params })
  }

  async function getBySlug(slug: string) {
    return get<ProductFamilyDetail>([DOMAIN, slug])
  }

  return {
    getAll,
    getBySlug,
  }
}
